"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require("../../browser/parser"),
    parseFragment = _require.parseFragment;

var _require2 = require("../helpers/namespaces.js"),
    HTML_NS = _require2.HTML_NS;

var _require3 = require("../helpers/shadow-dom.js"),
    isShadowRoot = _require3.isShadowRoot;

var NODE_TYPE = require("../node-type.js");

var _require4 = require("./serialization.js"),
    fragmentSerialization = _require4.fragmentSerialization; // https://w3c.github.io/DOM-Parsing/#the-innerhtml-mixin


exports.implementation =
/*#__PURE__*/
function () {
  function InnerHTMLImpl() {
    _classCallCheck(this, InnerHTMLImpl);
  }

  _createClass(InnerHTMLImpl, [{
    key: "innerHTML",
    // https://w3c.github.io/DOM-Parsing/#dom-innerhtml-innerhtml
    get: function get() {
      return fragmentSerialization(this, {
        requireWellFormed: true,
        globalObject: this._globalObject
      });
    },
    set: function set(markup) {
      var contextElement = isShadowRoot(this) ? this.host : this;
      var fragment = parseFragment(markup, contextElement);
      var contextObject = this;

      if (this.nodeType === NODE_TYPE.ELEMENT_NODE && this.localName === "template" && this.namespaceURI === HTML_NS) {
        contextObject = this._templateContents;
      }

      contextObject._replaceAll(fragment);
    }
  }]);

  return InnerHTMLImpl;
}();